import {
  SHOW_ACCOUNT,
  SHOW_ACCOUNTS,
  UPDATE_ACCOUNT,
  UPDATE_ACCOUNT_ERROR,
  UPDATE_PAYMENT,
  UPDATE_BILLING_PERIOD,
  UPDATE_PAYMENT_AND_SUBSCRIBE,
  UPDATE_TRIAL_AND_SUBSCRIBE,
  CREATE_SUBSCRIPTION,
  ENABLE_RENEW,
  CREATE_ACCOUNT,
  DELETE_ACCOUNT,
  DISABLE_RENEW,
} from './types';
import { Account, Accounts, Shortcode } from './api';

import { mapStripeErrors } from '../utils';

export const showAccountAction = id => async dispatch => {
  const response = await Account.show(id);
  if (!response.error) {
    dispatch({
      type: SHOW_ACCOUNT,
      payload: response.account,
      user: response.user,
    });
  } else {
    return response.error;
  }
};

export const showAccountsAction = () => async dispatch => {
  const response = await Accounts.show();
  if (!response.error) {
    dispatch({
      type: SHOW_ACCOUNTS,
      payload: response.accounts,
    });
  } else {
    return response.error;
  }
};

export const createAccountAction = (
  data,
  setSubmitting,
  setErrors,
) => async dispatch => {
  const response = await Accounts.create(data);
  if (!response.error) {
    dispatch({
      type: CREATE_ACCOUNT,
      payload: response,
    });
  } else {
    return response.error;
  }
};

export const deleteAccountAction = (
  data,
  setSubmitting,
  setErrors,
) => async dispatch => {
  const response = await Account.delete(data);
  if (!response.error) {
    dispatch({
      type: DELETE_ACCOUNT,
      payload: response,
    });
  } else {
    return response.error;
  }
};

export const updateAccountAction = (
  id,
  param,
  setSubmitting,
  setErrors,
) => async dispatch => {
  const response = await Account.update(id, param);
  if (!response.error) {
    dispatch({ type: UPDATE_ACCOUNT, payload: response });
    setSubmitting(false);
    return { status: 'success' };
  } else {
    dispatch({ type: UPDATE_ACCOUNT_ERROR });
    setSubmitting(false);
    if (response.textError.short_code) {
      setErrors({
        shortCode: `${param.short_code} ${response.textError.short_code[0]}`,
      });
    }
    return response;
  }
};

export const updatePaymentAction = (
  body,
  setSubmitting,
  setErrors,
) => async dispatch => {
  const response = await Account.updatePayment(body);
  if (!response.error) {
    dispatch({ type: UPDATE_PAYMENT, payload: response.data });
  } else {
    if (response.status === 422) {
      setErrors(mapStripeErrors(response.error.message));
    }
  }
  setSubmitting(false);
  return response;
};

export const updateBillingPeriodAction = (
  body,
  setSubmitting,
  setErrors,
) => async dispatch => {
  const response = await Account.updateBillingPeriod(body);
  setSubmitting(false);
  if (!response.error) {
    dispatch({ type: UPDATE_BILLING_PERIOD, payload: response.data });
    return response;
  } else {
    return {
      error: response.textError.message,
      status: response.status,
    };
  }
};

export const updatePaymentAndSubscribe = (
  body,
  setSubmitting,
  setErrors,
) => async dispatch => {
  const response = await Account.updatePaymentAndSubscribe(body);
  if (!response.error) {
    dispatch({ type: UPDATE_PAYMENT_AND_SUBSCRIBE, payload: response.data });
  } else {
    if (response.status === 422) {
      setErrors(mapStripeErrors(response.error.message));
    }
  }
  setSubmitting(false);
  return response;
};

export const updateTrialAndSubscribe = (
  body,
  setSubmitting,
  setErrors,
) => async dispatch => {
  const response = await Account.updateTrialAndSubscribe(body);
  if (!response.error) {
    dispatch({ type: UPDATE_TRIAL_AND_SUBSCRIBE, payload: response.data });
  } else {
    if (response.status === 422) {
      setErrors(mapStripeErrors(response.error.message));
    }
  }
  setSubmitting(false);
  return response;
};

export const createSubscriptionAction = () => async dispatch => {
  const response = await Account.createSubscription();
  if (!response.error) {
    dispatch({ type: CREATE_SUBSCRIPTION, payload: response.data });
    return response;
  } else {
    return response;
  }
};

export const enableRenewAction = () => async dispatch => {
  const response = await Account.enableRenew();
  if (!response.error) {
    dispatch({ type: ENABLE_RENEW, payload: response.data });
    return response;
  } else {
    return response;
  }
};

export const disableRenewAction = () => async dispatch => {
  const response = await Account.disableRenew();
  if (!response.error) {
    dispatch({ type: DISABLE_RENEW, payload: response.data });
    return response;
  } else {
    return response;
  }
};

export const checkShortcodeStatus = (code, setSubmitting) => async dispatch => {
  const response = await Shortcode.check(code);
  if (!response.error) {
    return response;
  } else {
    return response;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/content/actions.js